export const isOperator = {
  id: 'is',
  name: 'equals',
  value: true,
};

export const isNotOperator = {
  id: 'isNot',
  name: 'notEquals',
  value: false,
};

export const isNull = 'isNull';
export const isIn = 'isIn';
